import { Vector3 } from 'three';

export function totalMass(list) {
  let s = 0;
  for (let i = 0; i < list.length; i++) s += list[i].mass;
  return s;
}

export function centerOfMass(list) {
  const R = new Vector3();
  const M = totalMass(list);
  for (let i = 0; i < list.length; i++) {
    R.addScaledVector(list[i].position, list[i].mass);
  }
  return R.multiplyScalar(1 / M);
}

export function centerOfMassVelocity(list) {
  const V = new Vector3();
  const M = totalMass(list);
  for (let i = 0; i < list.length; i++) {
    V.addScaledVector(list[i].velocity, list[i].mass);
  }
  return V.multiplyScalar(1 / M);
}

export function shiftToComFrame(list) {
  const R = centerOfMass(list);
  const V = centerOfMassVelocity(list);
  for (let i = 0; i < list.length; i++) {
    list[i].position.sub(R);
    list[i].velocity.sub(V);
  }
}
